var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-2 text-center ex-page-content"},[_c('img',{attrs:{"width":"300","alt":"unavailable","src":_vm.unavailableSVG}}),_c('h2',{staticClass:"text-muted m-t-20 mb-2",domProps:{"innerHTML":_vm._s(_vm.unavailableText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }